import { CartAnalyticsEvent, NavigationEvent } from '@iheartjane/menu';

/**
 * Trace references to postMessageToIframeParent
 * @see https://docs.iheartjane.com/jane-docs/implementing-roots/embedding-checkout#client-side-event-callbacks
 */
export const HeadlessCartEvents = {
  ...CartAnalyticsEvent,
  ...NavigationEvent,
  HeadlessAppLoaded: 'headlessAppLoaded',
  InitiateExternalAuth: 'initiateExternalAuth',
} as const;

export type HeadlessCartEvents =
  (typeof HeadlessCartEvents)[keyof typeof HeadlessCartEvents];
